"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemorizedRuleType = void 0;
var MemorizedRuleType;
(function (MemorizedRuleType) {
    MemorizedRuleType["NORMAL"] = "Normal";
    MemorizedRuleType["AMOUNT_TYPE"] = "Amount";
    MemorizedRuleType["ACCOUNT_TYPE"] = "Account";
    MemorizedRuleType["ACCOUNT_AND_AMOUNT_TYPE"] = "Amount & Account";
})(MemorizedRuleType = exports.MemorizedRuleType || (exports.MemorizedRuleType = {}));
